import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'modal-view-multiplicador',
  imports: [CommonModule],
  templateUrl: './modal-view-multiplicador.component.html',
  styleUrl: './modal-view-multiplicador.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalViewMultiplicadorComponent {
  image = signal('assets/multiplicador.svg');
  isOpen = signal(false);




  openModal() {
    // console.log('Modal openModal() llamado - estableciendo isOpen a true');
    this.isOpen.set(true);
    // console.log('isOpen después de set:', this.isOpen());
  }



  closeModal() {
    this.isOpen.set(false);
  }




}
